export const dashboardSummary = {
  metrics: [
    {
      key: "newStoreApplications",
      label: "신규 매장 신청",
      value: 24,
      change: 12.5,
      note: "지난주 대비",
      tone: "primary",
    },
    {
      key: "pendingApprovals",
      label: "승인 대기",
      value: 18,
      change: -5.2,
      note: "어제 대비",
      tone: "warning",
    },
    {
      key: "activeStores",
      label: "이번 주 활성 매장",
      value: 312,
      change: 8.4,
      note: "지난주 대비",
      tone: "success",
    },
    {
      key: "userReports",
      label: "사용자 제보",
      value: 7,
      change: 16.7,
      note: "지난주 대비",
      tone: "danger",
    },
    {
      key: "seasonalMenus",
      label: "오늘 등록 제철 메뉴",
      value: 11,
      change: 22.2,
      note: "어제 대비",
      tone: "seasonal",
    },
    {
      key: "regionalPosts",
      label: "지역별 게시물",
      value: 428,
      change: 6.1,
      note: "이번 주 누적",
      tone: "neutral",
    },
  ],
  activityTrends: [
    { label: "월", stores: 42, posts: 68, reactions: 104 },
    { label: "화", stores: 48, posts: 74, reactions: 118 },
    { label: "수", stores: 45, posts: 81, reactions: 126 },
    { label: "목", stores: 56, posts: 88, reactions: 143 },
    { label: "금", stores: 63, posts: 102, reactions: 168 },
    { label: "토", stores: 59, posts: 96, reactions: 154 },
    { label: "일", stores: 61, posts: 110, reactions: 176 },
  ],
  regionDistribution: [
    { region: "서울", count: 186 },
    { region: "경기", count: 128 },
    { region: "부산", count: 54 },
    { region: "제주", count: 32 },
    { region: "강원", count: 18 },
    { region: "기타", count: 10 },
  ],
  recentActivities: [
    {
      id: "activity-1",
      occurredAt: "2026-06-15T10:42:00+09:00",
      storeName: "오후의 식탁",
      action: "신규 매장 신청",
      operator: "미배정",
      status: "pending",
    },
    {
      id: "activity-2",
      occurredAt: "2026-06-15T10:18:00+09:00",
      storeName: "윤기 한식당",
      action: "영업시간 수정",
      operator: "김운영",
      status: "approved",
    },
    {
      id: "activity-3",
      occurredAt: "2026-06-15T09:55:00+09:00",
      storeName: "바다담",
      action: "대표 메뉴 변경",
      operator: "이콘텐츠",
      status: "approved",
    },
    {
      id: "activity-4",
      occurredAt: "2026-06-15T09:31:00+09:00",
      storeName: "모닝 베이크",
      action: "신고 콘텐츠 접수",
      operator: "미배정",
      status: "reported",
    },
    {
      id: "activity-5",
      occurredAt: "2026-06-15T09:04:00+09:00",
      storeName: "제주 초록상",
      action: "제철 메뉴 등록",
      operator: "박제철",
      status: "active",
    },
  ],
};
